import React from "react";
import { toast, ToastPosition } from "react-toastify";

interface IToastifyData {
  message: string;
  type?: "info" | "error" | "success" | "warn";
  place?: ToastPosition;
}

export function toastify(data: IToastifyData): void {
  data.type
    ? toast[data.type](<p dangerouslySetInnerHTML={{ __html: data.message }}></p>, { position: data.place })
    : toast(<p dangerouslySetInnerHTML={{ __html: data.message }}></p>, { position: data.place });
}
